module.exports = __webpack_public_path__ + "static/email-75010a7a6e91d3dcf226535d6cedbb14.png";